﻿import { Tooltip } from '@mui/material';
import { withStyles } from '@mui/styles';

export const DefaultTooltip = withStyles({
  tooltipPlacementTop: {
    marginBottom: '4px !important',
  },
})(Tooltip);
